import { ISaveSearch } from 'store/sagas/apiService/types';
import { Amenity } from './entities';
import { every, isNil } from 'lodash';
import { config } from 'components/filters/config';
import { DecodedRouteParams } from 'config/routes';

export const searchHistortyToRouteParams = (search: ISaveSearch): DecodedRouteParams => {
  const query = search.query;
  const { __typename, ...amenities } = query.amenities as Partial<Record<Amenity, boolean>> & { __typename: string };
  const amenityArr = Object.keys(amenities).map(el => (query.amenities as any)[el] && el).filter(Boolean) as any;
  const areaRange = every(query.areaRange, isNil) ? undefined : query.areaRange;
  const bathsRange = every(query.bathsRange, isNil) ? undefined : query.bathsRange;
  const buildingClass = !query.buildingClass.length ? undefined : query.buildingClass;
  const floorRange = every(query.floorRange, isNil) ? undefined : query.floorRange;
  const generalCondition = !query.generalCondition.length ? undefined : query.generalCondition;
  const monthlyTaxRange = every(query.monthlyTaxRange, isNil) ? undefined : query.monthlyTaxRange;
  const ppmRange = every(query.ppmRange, isNil) ? undefined : query.ppmRange;
  const priceRange = every(query.priceRange, isNil) ? undefined : query.priceRange;
  const roomsRange = every(query.roomsRange, isNil) ? undefined : query.roomsRange;
  const sellerType = !query.sellerType.length ? undefined : query.sellerType;

  const noFilters = !amenityArr.length
     && !areaRange
     && !bathsRange
     && !buildingClass
     && !floorRange
     && !generalCondition
     && !monthlyTaxRange
     && !ppmRange
     && !priceRange
     && !roomsRange
     && !sellerType;

  return {
    term: search.locationDocIds && search.locationDocIds.length ? search.locationDocIds : [ search.term ],
    dealType: search.query.dealType,
    filters: noFilters ? undefined : {
      amenities: amenityArr.length ? amenityArr : undefined,
      areaRange,
      bathsRange,
      propertyTypes: buildingClass,
      floorRange,
      conditions: generalCondition,
      monthlyTaxRange,
      ppmRange,
      priceRange: priceRange ? [ priceRange[0] || 0, priceRange[1] || config.residential.budgetByDealType[search.query.dealType].budgetSliderProps.max ] : priceRange,
      roomsRange,
      seller: sellerType,
    },
    tracking_search_source: 'last_search_carousel_homepage',
  };
};
